import React, { Suspense, useEffect, useState } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

import { InstallPWAContainer } from "./base/contexts/InstallPwaContainer";
import { ThemeContext } from "./context/theme-context";
import { useService } from "./base/hooks/useService";
import { StorageService } from "@services/StorageService";
import { localstorageKeys } from "@const/store";
import { HelmetProvider } from "react-helmet-async";
import { RouterProvider } from "react-router-dom";
import useAppRoutes from "./hooks/useAppRoutes";
import MetaDecorator from "./components/MetaDecorator";
import styles from "@/index.module.scss";
import Loader from "@components/Loader";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";

const Context = () => {
  const router = useAppRoutes();

  const storageService = useService(StorageService);

  const getDefaultTheme = () => {
    const localStorageTheme = storageService.get(localstorageKeys.theme, "");
    const defaultTheme = localStorageTheme || "dark";
    storageService.set(localstorageKeys.theme, defaultTheme);
    return defaultTheme;
  };

  const [theme, setTheme] = useState(getDefaultTheme());

  useEffect(() => {
    let htmlElement = document.documentElement;
    htmlElement.classList = [];
    document.documentElement.classList.add(`theme-${theme}`);
  }, [theme]);

  return (
    <InstallPWAContainer>
      <I18nextProvider i18n={i18n}>
        <HelmetProvider>
          <GoogleOAuthProvider
            clientId={import.meta.env.VITE_APP_GOOGLE_CLIENT_ID}
          >
            <ThemeContext.Provider value={{ theme, setTheme }}>
              <Suspense fallback={<Loader className={styles.loader} />}>
                <RouterProvider router={router} />
              </Suspense>
              <MetaDecorator
                title="Honeymakers"
                description="Join Honeymakers to see exclusive content from your favourite creators or to earn money as a content creator or promoter"
                imageUrl="https://honeymakers.com/Honeymakers.jpg"
                imageAlt="Honeymakers"
              />
            </ThemeContext.Provider>
          </GoogleOAuthProvider>
        </HelmetProvider>
      </I18nextProvider>
    </InstallPWAContainer>
  );
};

export default Context;
